var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { BaseCheckpointModel } from '../BaseCheckpointModel';
export class PaymentDefaultCheckpoint extends BaseCheckpointModel {
    constructor(checkpoint) {
        super(checkpoint);
        this.paymentDefaults = [];
        this.individualPayments = [];
        this.fromJson(checkpoint);
    }
    fromJson(checkpoint) {
        checkpoint.paymentDefaults.forEach(x => {
            this.paymentDefaults.push({
                amount: x.amount,
                creditor: x.creditor,
                description: x.description,
                date: x.date
            });
        });
        checkpoint.individualPayments.forEach(x => {
            this.individualPayments.push({
                amount: x.amount,
                creditorName: x.creditorName,
                creditorNumber: x.creditorNumber,
                description: x.description,
                date: x.date,
                isForeignCreditor: x.isForeignCreditor
            });
        });
    }
    toJson() {
        return {
            paymentDefaults: this.paymentDefaults,
            individualPayments: this.individualPayments,
            quantityPaymentDefaults: this.quantityPaymentDefaults,
            totalAmountPaymentDefaults: this.totalAmountPaymentDefaults,
            quantityIndividualPayment: this.quantityIndividualPayment,
            totalAmountIndividualPayment: this.totalAmountIndividualPayment,
            type: this.type,
            comment: this.comment,
            discrepancy: this.discrepancy,
            researcherId: this.researcherId,
            verificationDate: this.calculateVerificationDate()
        };
    }
}
__decorate([
    observable
], PaymentDefaultCheckpoint.prototype, "paymentDefaults", void 0);
__decorate([
    observable
], PaymentDefaultCheckpoint.prototype, "individualPayments", void 0);
__decorate([
    observable
], PaymentDefaultCheckpoint.prototype, "quantityPaymentDefaults", void 0);
__decorate([
    observable
], PaymentDefaultCheckpoint.prototype, "totalAmountPaymentDefaults", void 0);
__decorate([
    observable
], PaymentDefaultCheckpoint.prototype, "quantityIndividualPayment", void 0);
__decorate([
    observable
], PaymentDefaultCheckpoint.prototype, "totalAmountIndividualPayment", void 0);
__decorate([
    action
], PaymentDefaultCheckpoint.prototype, "fromJson", null);
__decorate([
    action
], PaymentDefaultCheckpoint.prototype, "toJson", null);
